import React, { useState } from 'react';
import { Container } from 'reactstrap';
import { Helmet } from "react-helmet";
import "react-datepicker/dist/react-datepicker.css";
import Main from '../../layout/main'
import AvailableProjects from '../../components/projects/availableProjects';
const Projects = (props) => {
    const [showLimitBanner, setShowLimitBanner] = useState(true);
    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="description" content=" Easy Bids Pro is the easiest way to bid on projects in your area. Whether it's plumbing, carpentry, landscaping or anything else you need done, find an easy project near you and get started today!" />
                <title>Bidding - Easy Bids Pro</title>
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></link>
            </Helmet>
            <Main additionalClass_main="projects">
                <section className="">
                    {props.fair_use?.limit_reached && showLimitBanner && (
                        
                        <div style={{
                            backgroundColor: '#FFFBE6',
                            padding: '16px 20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: '12px',
                            position:'sticky',
                            top: 80,
                            width: '100%',
                            zIndex: 1000,
                        }}>
                            <Container style={{ display: 'flex',justifyContent: 'space-between', }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
                                    <div style={{
                                        width: '18px',
                                        height: '18px',
                                        borderRadius: '50%',
                                        border: '1px solid #B8860B',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexShrink: 0
                                    }}>
                                        <span style={{ color: '#B8860B', fontSize: '12px', fontWeight: 'bold' }}>!</span>
                                    </div>
                                    <p style={{
                                        color: '#B8860B',
                                        fontSize: '14px',
                                        margin: 0,
                                    }}>
                                        You have reached your daily lead unlock limit. The limit will reset in {props.fair_use?.limit_resets_in} hours.
                                    </p>
                                </div>
                                <button
                                    onClick={() => setShowLimitBanner(false)}
                                    style={{
                                        width: '24px',
                                        height: '24px',
                                        borderRadius: '50%',
                                        backgroundColor: 'white',
                                        border: 'none',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexShrink: 0,
                                        padding: 0
                                    }}
                                    aria-label="Close"
                                >
                                    <span style={{ color: '#333', fontSize: '18px', fontWeight: 'bold', lineHeight: '1' }}>×</span>
                                </button>
                            </Container>
                        </div>
                        
                    )}
                    <Container className="mt-4 mb-4">
                        <AvailableProjects
                            availableLoading={props.availableLoading}
                            projectAvailableData={props.availableData}
                            pagination={props.pagination}
                            currentPage={props.currentPage}
                            onPageChange={props.onPageChange}
                            serviced_zipcodes={props.serviced_zipcodes}
                            serviced_zipcodes_count={props.serviced_zipcodes_count}
                            onRefetch={props.onRefetch}
                        />
                    </Container>
                </section>
            </Main>
        </div>
    );
}

export default Projects;
